<template>
  <div id="app">
    <Navbar  />
    <router-view/>
  </div>
</template>

<script>
import Navbar from "./Navbar";


export default {
  name: "app",
  data() {
    return {
      msg: "Welcome to Your Vue.js  2App",
    };
  },
  components: {
    Navbar,
  },
};
</script>

<style lang="scss">

#app {
  color: #2c3e50;
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.centre {
  background-color:rgb(20,20,20);
  margin: auto;
  padding-left: 4px;
  padding-right: 4px;
  max-width: 145vh;
  background-size: contain;
  text-align: center;
  -webkit-box-shadow: 0px 0px 620px 115px rgba(0, 0, 0, 0.85);
  -moz-box-shadow: 0px 0px 620px 115px rgba(0, 0, 0, 0.85);
  box-shadow: 0px 0px 620px 115px rgba(0, 0, 0, 0.85);
}

html, 
body {
  background-image: url('./assets/hex.png');
  background-repeat: repeat;
  background-color: rgb(25, 25, 25);
}

</style>



// WEBPACK FOOTER //
// src/App.vue